import { initialState } from "./selectors";
import {
  GET_COLUMNS_REQUEST,
  GET_COLUMNS_SUCCESS,
  GET_ORGA_TASKS_REQUEST,
  GET_ORGA_TASKS_SUCCESS,
  SILENT_TASKS_UPDATE,
} from "./actions";

export default function brand(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case GET_COLUMNS_REQUEST:
      return {
        ...state,
      };
    case GET_COLUMNS_SUCCESS:
      return {
        ...state,
        columns: payload,
      };
    case GET_ORGA_TASKS_REQUEST:
      return {
        ...state,
      };
    case GET_ORGA_TASKS_SUCCESS:
      return {
        ...state,
        tasks: payload,
      };
    case SILENT_TASKS_UPDATE:
      const newTasks = state.tasks.map(t => {
        if (t._id === payload.taskId) {
          t.column = payload.column;
        }
        return t;
      });
      return {
        ...state,
        tasks: newTasks,
        columns: {
          ...state.columns,
          tasksOrder: payload.tasksOrder,
        },
      };
    default:
      return state;
  }
}
